import { render, staticRenderFns } from "./PasswordInput.vue?vue&type=template&id=2b968fbe&scoped=true&"
import script from "./PasswordInput.vue?vue&type=script&lang=js&"
export * from "./PasswordInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b968fbe",
  null
  
)

export default component.exports